import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import HeaderCTA from "@components/V2/Banners/HeaderCTA"
import { storyblokLinkToYocoLink } from "@utils/storyblok"

const StoryblokHeaderCTABanner = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.HeaderCTABanner>) => {
  return (
    <HeaderCTA
      header={blok.header}
      body={blok.body}
      ctaLabel={blok.ctaLabel}
      ctaLink={storyblokLinkToYocoLink(blok.ctaLink) ?? ""}
      mobileGridOrder={mobileGridOrder}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokHeaderCTABanner
